var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_1892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 17V10.25L16.735 4.5C16.8202 4.41476 16.8876 4.31336 16.9331 4.20174C16.9786 4.09012 17.0013 3.97053 17 3.85V3C17 2.86739 16.9473 2.74021 16.8536 2.64645C16.7598 2.55268 16.6326 2.5 16.5 2.5H1.5C1.36739 2.5 1.24021 2.55268 1.14645 2.64645C1.05268 2.74021 1 2.86739 1 3V3.835C1.00009 3.95309 1.02356 4.07 1.06904 4.17898C1.11452 4.28797 1.18112 4.38687 1.265 4.47L7 10.29V15.39L11 17Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.74 2.5H1.24002C1.17458 2.50505 1.11348 2.53465 1.06897 2.58288C1.02445 2.6311 0.999821 2.69437 1.00002 2.76V3.62C0.999415 3.70815 1.01634 3.79553 1.04982 3.87708C1.0833 3.95862 1.13265 4.0327 1.19502 4.095L7.19502 10.095V15.095L10.82 16.9V10.085L16.82 4.085C16.9348 3.96118 16.999 3.79884 17 3.63V2.76C17 2.69104 16.9726 2.62491 16.9239 2.57615C16.8751 2.52739 16.809 2.5 16.74 2.5Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_1892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.bd643f0741b6d28063c0b321d0aa09be.svg";
export { ForwardRef as ReactComponent };